import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    content: String,
    key: String,
    autoshow: Boolean,
    placement: String
  }

  connect() {
    if (!window.bootstrap || !window.bootstrap.Popover) return

    this.popover = new window.bootstrap.Popover(this.element, {
      container: "body",
      trigger: "manual",
      placement: this.placementValue || "top",
      html: true,
      sanitize: false,
      content: this.renderContent(),
      popperConfig: { strategy: "fixed" }
    })

    this.boundDocClick = this.onDocumentClick.bind(this)
    document.addEventListener("pointerdown", this.boundDocClick, true)

    if (this.autoshowValue && !this.dismissed()) {
  setTimeout(() => {
    if (!this.popover) return

    this.popover.show()

    // Force Popper to recalc multiple times
    const popper = this.popover._popper
    if (!popper) return

    popper.update()

    // One more update after next paint
    requestAnimationFrame(() => {
      popper.update()
    })

  }, 400) // slightly longer delay
}
  }

  disconnect() {
    if (this.popover) this.popover.dispose()

    if (this.boundDocClick) {
      document.removeEventListener("pointerdown", this.boundDocClick, true)
    }
  }

  toggle(event) {
    if (event) event.preventDefault()
    if (!this.popover) return

    const tip = document.querySelector(".popover.show")
    if (tip) {
      this.popover.hide()
    } else {
      this.popover.show()
    }
  }

  renderContent() {
    let text = this.contentValue || ""
    text = text.replace(/^data-help-popover-content-value=\s*/i, "").trim()

    return `
      <div class="d-flex align-items-start gap-2">
        <div>${this.escapeHtml(text).replace(/\n/g, "<br>")}</div>
        <button type="button"
                class="btn btn-sm btn-outline-secondary ms-auto"
                data-help-popover-dismiss="1"
                aria-label="Close">×</button>
      </div>
    `
  }

  onDocumentClick(event) {
    const target = event.target?.nodeType === 3 ? event.target.parentElement : event.target
    if (!target) return

    const btn = target.closest("[data-help-popover-dismiss='1']")
    if (!btn) return

    event.preventDefault()
    event.stopPropagation()
    this.dismiss()
  }

  dismiss() {
    if (this.popover) this.popover.hide()
    this.rememberDismissed()
  }

  dismissed() {
    const key = this.storageKey()
    if (!key) return false
    return localStorage.getItem(key) === "1"
  }

  rememberDismissed() {
    const key = this.storageKey()
    if (!key) return
    localStorage.setItem(key, "1")
  }

  storageKey() {
    const k = (this.keyValue || "").trim()
    return k ? `jefa:popover:${k}` : null
  }

  escapeHtml(str) {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;")
  }
}
